import axios from 'axios'

let memoryCache: Record<string, any> = {}
export default async function getWithInMemoryCache (url: string, queryParams: Object) {
  const cacheKey = url + JSON.stringify(queryParams)

  if (memoryCache[cacheKey]) {
    return memoryCache[cacheKey]
  }

  try {
    const response = await axios.get(url, {
      params: queryParams
    })

    memoryCache[cacheKey] = response.data
  } catch (error) {
    throw new Error(error)
  }

  return memoryCache[cacheKey]
}

getWithInMemoryCache.clearCache = function () {
  memoryCache = {}
}
